export default "__VITE_ASSET__an8y6IiD__"